import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ConsentModal } from "../components/consent/ConsentModal";

let ORIGINS = [];
const post = (msg) => ORIGINS.forEach((o) => window.parent?.postMessage({ source: "aegis", ...msg }, o));

export default function EmbedConsent() {
  const [busy, setBusy] = useState(false);
  const q = new URLSearchParams(window.location.search);
  useEffect(() => { api.get(`/verify/config${window.location.search}`).then((r) => { ORIGINS = r.data.embed_origins || []; }).catch(() => {}); }, []);
  useEffect(() => { document.documentElement.style.background = "transparent"; document.body.style.background = "transparent"; }, []);
  const form = { customer_name: q.get("name") || "", customer_email: q.get("email") || "", amount: Number(q.get("amount") || 0), product_name: q.get("product") || "Purchase" };
  const confirm = async (signed) => {
    setBusy(true);
    try {
      const { data } = await api.post("/consent", { ...form, ...signed });
      post({ type: "consent.captured", consent_id: data.consent.id, transaction_id: data.transaction.id, hash: data.consent.hash });
    } catch (e) { post({ type: "consent.error", error: e.response?.data?.detail || "Consent capture failed" }); }
    setBusy(false);
  };
  return (
    <div className="min-h-screen bg-transparent" data-testid="embed-consent-page">
      <ConsentModal open onOpenChange={(v) => !v && post({ type: "consent.cancelled" })} onConfirm={confirm} busy={busy} amount={form.amount} email={form.customer_email} name={form.customer_name} />
    </div>
  );
}
